"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeIndicator = exports.TypeIcon = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const CheckIcon_1 = __importDefault(require("@8x8/oxygen-icon/novo/CheckIcon"));
const ExclamationIcon_1 = __importDefault(require("@8x8/oxygen-icon/novo/ExclamationIcon"));
const ErrorIcon_1 = __importDefault(require("@8x8/oxygen-icon/novo/ErrorIcon"));
const InfoCircleIcon_1 = __importDefault(require("@8x8/oxygen-icon/novo/InfoCircleIcon"));
const getMarkingColor_1 = __importDefault(require("../styled/utils/getMarkingColor"));
const types_1 = require("../types");
const { novo } = oxygen_theme_1.default;
const TypeIcon = ({ theme, type }) => {
    const props = {
        style: { marginRight: novo.spacing03, flexShrink: 0 },
        color: (0, getMarkingColor_1.default)({ theme, type }),
        size: theme.iconSize,
    };
    switch (type) {
        case types_1.toastTypes.success: {
            return react_1.default.createElement(CheckIcon_1.default, { ...props });
        }
        case types_1.toastTypes.warning: {
            return react_1.default.createElement(ExclamationIcon_1.default, { ...props });
        }
        case types_1.toastTypes.error: {
            return react_1.default.createElement(ErrorIcon_1.default, { ...props });
        }
        case types_1.toastTypes.info:
        default: {
            return react_1.default.createElement(InfoCircleIcon_1.default, { ...props });
        }
    }
};
exports.TypeIcon = TypeIcon;
const TypeIndicator = styled_components_1.default.div `
  width: 4px;
  border-radius: 2px;
  background: ${getMarkingColor_1.default};
  align-self: normal;
  margin-right: ${novo.spacing05};
`;
exports.TypeIndicator = TypeIndicator;
TypeIndicator.displayName = 'TypeIndicator';
